"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateRangeValue = exports.validateFormulaValue = exports.validateStringValue = exports.validateValue = exports.validateResult = exports.validateResults = exports.validateCondition = exports.validateConditions = exports.validateRuleName = exports.ruleValidator = void 0;

var _flatMap = _interopRequireDefault(require("lodash/flatMap"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ruleValidator = function ruleValidator(rule) {
  var ruleValidations = [];
  ruleValidations = ruleValidations.concat(validateRuleName(rule.name));
  ruleValidations = ruleValidations.concat(validateConditions(rule.conditions));
  ruleValidations = ruleValidations.concat(validateResults(rule.results));
  return ruleValidations.filter(function (x) {
    return x !== undefined;
  });
};

exports.ruleValidator = ruleValidator;

var validateRuleName = function validateRuleName(name) {
  if (!(name && name.length)) {
    return ['Constraints must have a name.'];
  }

  return [];
};

exports.validateRuleName = validateRuleName;

var validateConditions = function validateConditions(conditions) {
  if (!conditions || conditions.length <= 0) {
    return ['Constraints must have at least one condition.'];
  }

  return (0, _flatMap["default"])(conditions.map(function (condition) {
    return validateCondition(condition);
  }));
};

exports.validateConditions = validateConditions;

var validateCondition = function validateCondition(condition) {
  if (!(condition.attribute && condition.operator)) {
    return ['Conditions must have an attribute set.'];
  }

  if (!(condition.values && condition.values.length > 0)) {
    return ['Conditions must have at least 1 value.'];
  }

  return (0, _flatMap["default"])(condition.values.map(function (value) {
    return validateValue(value);
  }));
};

exports.validateCondition = validateCondition;

var validateResults = function validateResults(results) {
  if (!results || results.length <= 0) {
    return ['Constraints must have at least one result.'];
  }

  return (0, _flatMap["default"])(results.map(function (result) {
    return validateResult(result);
  }));
};

exports.validateResults = validateResults;

var validateResult = function validateResult(result) {
  if (!(result.attribute && result.operator)) {
    return ['Results must have an attribute set.'];
  }

  if (!(result.values && result.values.length > 0)) {
    return ['Results must have at least 1 value.'];
  }

  return (0, _flatMap["default"])(result.values.map(function (value) {
    return validateValue(value);
  }));
};

exports.validateResult = validateResult;

var validateValue = function validateValue(value) {
  if (!value.type) {
    return ['Value malformed.  It must have a type.'];
  }

  switch (value.type) {
    case 'value':
      return validateStringValue(value);

    case 'range':
      return validateRangeValue(value);

    case 'formula':
      return validateFormulaValue(value);

    default:
      return [];
  }
};

exports.validateValue = validateValue;

var validateStringValue = function validateStringValue(value) {
  if (!value.value) {
    return ['A value must be defined.'];
  }

  return [];
};

exports.validateStringValue = validateStringValue;

var validateFormulaValue = function validateFormulaValue(value) {
  if (!value.formula) {
    return ['A formula must be defined.'];
  }

  return [];
};

exports.validateFormulaValue = validateFormulaValue;

var validateRangeValue = function validateRangeValue(value) {
  if (!value.range) {
    return ['A range must be defined'];
  }

  return [];
};

exports.validateRangeValue = validateRangeValue;